module.exports = __webpack_public_path__ + "img/441.c587fbfc.jpg";